module.exports = __webpack_public_path__ + "img/unc-chapel-hill.4cb2128f.png";